<template>
  <div class="row card">
    <!-- Header -->
    <div class="align-items-center">
      <div class="border-0 mb-4">
        <div
          class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap"
        >
          <h3 class="fw-bold mb-0">Statistics</h3>
        </div>
      </div>
    </div>

    <div class="row overflow-auto">
      <div class="col-sm-12">
        <!-- Search Bar -->
        <div class="row">
          <div class="w-100 col-sm-12 col-md-6">
            <div id="patient-table_filter" class="dataTables_filter">
              <div class="row">
                <!-- Operator -->
                <div class="col">
                  <label class="form-label">Operator</label>
                  <select
                    v-model="request.operatorId"
                    class="form-select"
                    name="specialityDropdown"
                  >
                    <option
                      v-for="(speciality, index) in operators"
                      :key="index"
                      :value="speciality.id"
                    >
                      {{ speciality.name }}
                    </option>
                  </select>
                </div>

                <!-- Date From -->
                <div class="col">
                  <label class="form-label">From Date</label>
                  <br />
                  <input
                    type="date"
                    v-model="request.fromDate"
                    v-validate="{ required: true }"
                    name="dateField"
                    id="date"
                    class="form-control"
                    required=""
                  />
                  <span class="inputError">
                    {{ errors.first("dateField") }}
                  </span>
                </div>

                <!-- Date To -->
                <div class="col">
                  <label class="form-label">To Date</label>
                  <br />
                  <input
                    type="date"
                    v-model="request.toDate"
                    v-validate="{ required: true }"
                    name="dateField2"
                    id="date"
                    class="form-control"
                    required=""
                  />
                  <span class="inputError">
                    {{ errors.first("dateField2") }}
                  </span>
                </div>

                <!-- Partner -->
                <div class="col" v-if="user.role === 'Admin'">
                  <label class="form-label">Partner</label>
                  <select
                    class="form-select"
                    v-model="request.partner"
                    name="specialityDropdown"
                  >
                    <option></option>
                    <option
                      v-for="(partner, index) in partners"
                      :key="index"
                      :value="partner.name"
                    >
                      {{ partner.name }}
                    </option>
                  </select>
                  <span class="inputError">
                    {{ errors.first("specialityDropdown") }}
                  </span>
                </div>

                <!-- Buttons -->
                <div class="col d-flex align-items-end">
                  <button @click.prevent="search" class="btn btn-primary">
                    <i class="icofont-ui-search"></i>
                  </button>
                  <button
                    @click.prevent="exportt"
                    class="btn btn-success ml-1 white-text"
                  >
                    <i class="icofont-download"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <span><b>Total SMS - </b>{{ totalCount }}</span>
        <br /><br />

        <!-- Table -->
        <table
          id="patient-table"
          class="table table-striped table-bordered align-middle mb-0 nowrap dataTable no-footer dtr-inline"
          style="width: 100%"
          role="grid"
          aria-describedby="patient-table_info"
        >
          <thead>
            <tr role="row">
              <th class="text-center">Transaction ID</th>
              <th class="text-center">Partner Name</th>
              <th class="text-center">Sent Date (Partner)</th>
              <th class="text-center">Short Number / Sender ID</th>
              <th class="text-center">Mobile Number</th>
              <th class="text-center">SMS Text</th>
              <th class="text-center">SMS Count</th>
              <th class="text-center">SMS Sent Date</th>
              <th class="text-center">Status</th>
              <th class="text-center">Status Received At</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="template in templates"
              :key="template.id"
              class="text-center"
            >
              <td>{{ template.transactionId }}</td>
              <td>{{ template.partner }}</td>
              <td>{{ format_date(template.sendDate) }}</td>
              <td>{{ template.phoneFrom }}</td>
              <td>{{ template.phoneTo }}</td>
              <td>{{ template.smsText }}</td>
              <td>{{ template.smsCount }}</td>
              <td>{{ format_date(template.date) }}</td>

              <td v-if="template.status == 0">SCHEDULED</td>
              <td v-else-if="template.status == 1">ENROUTE</td>
              <td v-else-if="template.status == 2">DELIVERED</td>
              <td v-else-if="template.status == 3">EXPIRED</td>
              <td v-else-if="template.status == 4">DELETED</td>
              <td v-else-if="template.status == 5">UNDELIVERABLE</td>
              <td v-else-if="template.status == 6">ACCEPTED</td>
              <td v-else-if="template.status == 7">UNKNOWN</td>
              <td v-else-if="template.status == 8">REJECTED</td>
              <td v-else-if="template.status == 9">SKIPPED</td>
              <td v-else></td>

              <td>{{ format_date(template.statusDate) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <br />
    <pagination
      :totalPages="totalPage"
      :perPage="request.pageSize"
      :currentPage="currentPage"
      @pagechanged="onPageChange"
    />
  </div>
</template>

<script>
import jwtInterceptor from "../../jwt.interceptor";
import Pagination from "../parts/site/Pagination.vue";
import user from "../../store/user";
import moment from "moment";

export default {
  name: "MessageTemplates",
  components: {
    Pagination,
  },
  data() {
    return {
      templates: [],
      user: {},
      totalCount: 0,
      request: {
        pageNumber: 1,
        pageSize: 10,
        fromDate: moment().format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
        partner: "",
        operatorId: 1,
      },
      currentPage: 1,
      totalPage: 0,
      operators: [
        { name: "Azercell", id: 1 },
        { name: "Bakcell", id: 2 },
        { name: "Nar", id: 3 },
      ],

      partners: [],

      leng: 0,
    };
  },
  methods: {
    onPageChange(page) {
      this.request.pageNumber = page;
      this.search();
    },

    exportt() {
      jwtInterceptor
        .get(
          this.$store.getters.getUrl + "/Report/ExportPartnerStatisticReport",
          { params: this.request, responseType: "blob" }
        )
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "statistika");
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {});
    },
    search() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Report/GetPartnerStatisticReport", {
          params: this.request,
        })
        .then((response) => {
          this.templates = response.data.result.items;
          this.totalPage = response.data.result.totalPages;
          this.totalCount = response.data.result.totalCount;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Xəta baş verdi!", {
            position: "top-right",
          });
        });
    },
    getPartners() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/GeneralPartners/GetUserPartners")
        .then((response) => {
          this.partners = response.data.result;
        });
    },
    format_date(k) {
      return k ? moment(k).format("DD.MM.Y HH:mm:ss") : "";
    },
  },
  created() {
    this.user = user.getters.getUser;
    if (this.user.role === "Partner") {
      this.request.partner = this.user.userName;
    } else {
      this.getPartners();
    }
  },
};
</script>

<style>
[data-theme="high-contrast"] {
  .table-striped > tbody > tr:nth-of-type(odd) > * {
    color: white !important;
  }
}
</style>
